import React from 'react'
import { Box, CircularProgress } from '@mui/material'
import { ui } from '../../utils/uiTokens'

interface Props {
    isLoading: boolean
}

/** Маркер конца списка: наблюдатель следит за ним, чтобы догрузить следующую страницу. */
const Sentinel = React.forwardRef<HTMLDivElement, Props>(({ isLoading }, ref) => (
    <Box
        ref={ref}
        sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 48,
        }}
    >
        {isLoading && <CircularProgress size={22} sx={{ color: ui.pink }} />}
    </Box>
))

export default Sentinel
